class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  onMouseEnter() {
    clearTimeout(this.hoverCloseTimeout);
    // Wait briefly before opening so a pointer just passing over the nav on its
    // way somewhere else doesn't flash the panel open.
    this.hoverOpenTimeout = setTimeout(() => this.open(), 120);
  }

  onMouseLeave() {
    clearTimeout(this.hoverOpenTimeout);
    // The panel drops from the full header bar, not from the label directly
    // beneath it, so the pointer briefly crosses empty space to reach it.
    // Delay the close so that crossing doesn't immediately dismiss the menu.
    this.hoverCloseTimeout = setTimeout(() => this.close(), 250);
  }

  // A CSS animation on the panel only played on the first open: browsers keep
  // a closed <details>' content styled (just hidden), so the finished animation
  // never restarted. Driving it from here replays it on every open.
  animateOpen() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.content.animate(
      [
        { opacity: 0, transform: 'translateY(-1.5rem)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      { duration: 400, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' }
    );
  }

  open() {
    // Pointer came back while the panel was fading out: run the fade back up
    // instead of letting it finish closing.
    if (this.closeAnimation) {
      const animation = this.closeAnimation;
      this.closeAnimation = null;
      animation.onfinish = () => animation.cancel();
      animation.reverse();
    }

    this.mainDetailsToggle.open = true;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  // Removing [open] hides the panel at once, so fade it out first and only
  // close the <details> once that has finished.
  close() {
    if (!this.mainDetailsToggle.open || this.closeAnimation) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return super.close();

    this.closeAnimation = this.content.animate(
      [
        { opacity: 1, transform: 'translateY(0)' },
        { opacity: 0, transform: 'translateY(-1.5rem)' },
      ],
      { duration: 300, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', fill: 'forwards' }
    );
    this.closeAnimation.onfinish = () => {
      const animation = this.closeAnimation;
      this.closeAnimation = null;
      super.close();
      animation.cancel();
    };
  }

  onToggle() {
    if (this.mainDetailsToggle.open) this.animateOpen();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
